export default __webpack_public_path__ + "static/media/wildflowers.87790ddd.png";